<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Parent Accounts
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { errorMessageMixin } from '../shared';
export default {
  name: "Admin",
  mixins: [errorMessageMixin],
  computed: {
  },
};
</script>
